









































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { UploadFile, ChangeLight } from "../request";
@Component({})
export default class Name extends Vue {
  @Prop()
  private ifShow: any;
  @Watch("ifShow", { immediate: true })
  private async ifShowChange() {
    this.visible = this.ifShow;
    if (this.ifShow) {
      // 关闭紫光
      console.log("打开弹框后：紫外光-OFF");
      const res = await window.electronMyAPI.changeLight("紫外光-OFF");
      if (res) {
        this.$store.commit("updateIfShowZiwai", false);
        console.log("返回值：" + res);
        // 打开均匀光
        console.log("打开弹框后：白光-ON-100");
        window.electronMyAPI.changeLight("白光-ON-100");
      }
      this.getCameraDevices();
    } else {
    }
  }
  private visible: any = false;
  private stream: any = "";
  private photoData: any = "";
  private imgData: any = [];
  private imgs: any = [];
  private devices: any = [];
  private cDevice: any = {};
  private filming: any = false;
  private chunks: any = [];
  private startTime: number | null = null;
  private intervalId: any = null;
  private formattedTime: any = "";
  private mediaRecorder: any = null;
  private recording: any = false;
  private recordedVideoUrl: any = "";
  private videoData: any = "";
  private cancel() {
    this.$emit("cancel");
    if (this.stream) {
        this.stream.getTracks().forEach((track: any) => track.stop());
      }
      this.resetCamera();
      this.imgs = [];
      this.imgData = [];
      this.devices = [];
      this.cDevice = {};
      this.resetData();
      // 关闭均匀光
      console.log("关闭弹框后：白光-OFF");
      window.electronMyAPI.changeLight("白光-OFF");
      this.filming = false;
  }
  private getFormattedTime() {
    if (!this.startTime) return "00:00:00";
    let str: any = "";
    const diff = Date.now() - this.startTime;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    // str = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    //   2,
    //   "0"
    // )}:${String(seconds).padStart(2, "0")}`;
    str = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
    this.formattedTime = str;
    if (seconds == 6) {
      this.stopRecording();
    }
  }
  private startRecording() {
    this.startTime = Date.now();
    this.intervalId = setInterval(() => {
      // 这里实际上不需要做什么，因为formattedTime是计算属性，会自动更新
      this.getFormattedTime();
    }, 1000);
    if (MediaRecorder.isTypeSupported("video/webm")) {
      this.chunks = [];
      this.mediaRecorder = new MediaRecorder(this.stream, {
        mimeType: "video/webm",
      });
      this.mediaRecorder.ondataavailable = (e: any) => {
        if (e.data && e.data.size > 0) {
          this.chunks.push(e.data);
        }
      };
      this.mediaRecorder.onstop = () => {
        const recordedBlob = new Blob(this.chunks, { type: "video/MP4" });
        this.chunks = [];
        this.recordedVideoUrl = URL.createObjectURL(recordedBlob);
        this.videoData = recordedBlob;
      };
      this.mediaRecorder.start();
      this.recording = true;
    } else {
      console.error("不支持录制视频");
    }
  }
  private stopRecording() {
    if (this.recording) {
      this.mediaRecorder.stop();
      this.mediaRecorder = null;
      this.recording = false;
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
        this.startTime = null;
      }
    }
  }
  private resetRecording() {
    this.resetData();
    this.startCamera();
    setTimeout(() => {
      this.startRecording();
    }, 1000);
  }
  private resetData() {
    if (this.stream) {
      this.stream.getTracks().forEach((track: any) => {
        track.stop();
      });
    }
    this.recordedVideoUrl = "";
    this.videoData = "";
    this.recording = false;
    this.stream = null;
    this.mediaRecorder = null;
    this.chunks = [];
    this.startTime = null;
  }

  private selectDevice(item: any) {
    this.cDevice = item;
    this.startCamera();
  }
  private base64ToBlob(base64Data: string, contentType = ""): Blob {
    contentType = contentType || base64Data.split(",")[0].split(":")[1];
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data.split(",")[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  private async startCamera() {
    try {
      this.stream = await navigator.mediaDevices.getUserMedia({
        // video: true,
        video: {
          deviceId: { exact: this.cDevice.deviceId },
          width: { exact: 3840 },
        },
      });
      (this.$refs.video as any).srcObject = this.stream;
      (this.$refs.video2 as any).srcObject = this.stream;
    } catch (err) {
      console.error("Error accessing the camera:", err);
      this.$message.warning("请再点击一次");
      // this.devices = [];
      this.cDevice = {};
      this.resetData();
    }
  }
  private resetCamera() {
    // 重置photoData和Canvas
    this.stream = "";
    this.photoData = "";
    const canvas = this.$refs.canvas as HTMLCanvasElement;

    if (canvas) {
      const context: any = canvas.getContext("2d");
      context.clearRect(0, 0, canvas.width, canvas.height);
    }
  }
  private sure() {
    // 将 photoData 转换为 Blob 对象
    // const blob = this.base64ToBlob(this.photoData);
    // 获取当前时间的时间戳（毫秒级）
    const timestamp = Date.now();

    // 将时间戳转换为字符串，并作为文件名的一部分
    const filename = `photo_${timestamp}.mp4`;
    // FormData 对象
    const form = new FormData();
    // Blob 对象作为文件添加到表单中
    form.append("file", this.videoData, filename); // 可以指定文件名

    UploadFile(this, form).then((res: any) => {
      this.$emit("sure", res.data);
    });
  }
  private upload(d: any) {
    return new Promise((resolve, reject) => {
      // 将 photoData 转换为 Blob 对象
      const blob = this.base64ToBlob(d);
      // 获取当前时间的时间戳（毫秒级）
      const timestamp = Date.now();
      const filename = `${timestamp}.jpg`;
      // FormData 对象
      const form = new FormData();
      // Blob 对象作为文件添加到表单中
      form.append("file", blob, filename); // 可以指定文件名

      UploadFile(this, form)
        .then((res: any) => {
          this.imgs.push(res.data);
          resolve(res.data);
        })
        .catch(() => {
          reject();
        });
    });
  }
  private async getCameraDevices() {
    const loading = this.$loading({
      lock: true,
      text: "查找设备中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        // alert("enumerateDevices 不可用");
        loading.close();
        // this.$message.warning("enumerateDevices 不可用");
        setTimeout(() => {
          this.getCameraDevices2();
        }, 1000);
        return;
      }

      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          console.log('设备列表')
          console.log(devices);
          this.devices = devices.filter(
            (device) => device.kind === "videoinput"
          );
          loading.close();
          if (this.devices.length == 0) {
            // this.$message.warning("没有符合条件的设备");
            setTimeout(() => {
              this.getCameraDevices2();
            }, 1000);
          }
        })
        .catch((error) => {
          console.error("列出摄像头时发生错误:", error);
          loading.close();
          // this.$message.warning("没有符合条件的设备");
          setTimeout(() => {
            this.getCameraDevices2();
          }, 1000);
        });
    } catch (err) {
      console.error("Error accessing the camera:", err);
      loading.close();
      // this.$message.warning("没有符合条件的设备");
      setTimeout(() => {
        this.getCameraDevices2();
      }, 1000);
    }
  }
  private async getCameraDevices2() {
    console.log("再次查找设备");
    const loading = this.$loading({
      lock: true,
      text: "再次查找设备中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        // alert("enumerateDevices 不可用");
        loading.close();
        this.$message.warning("enumerateDevices 不可用");
        return;
      }

      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          console.log('设备列表')
          console.log(devices);
          this.devices = devices.filter(
            (device) => device.kind === "videoinput"
          );
          loading.close();
          if (this.devices.length == 0) {
            this.$message.warning("没有符合条件的设备");
          }
        })
        .catch((error) => {
          console.error("列出摄像头时发生错误:", error);
          loading.close();
          this.$message.warning("没有符合条件的设备");
        });
    } catch (err) {
      console.error("Error accessing the camera:", err);
      loading.close();
      this.$message.warning("没有符合条件的设备");
    }
  }
  private mounted() {
    // this.getCameraDevices();
  }
}
